import { render, staticRenderFns } from "./piutang.vue?vue&type=template&id=1c21f674&scoped=true"
import script from "./piutang.vue?vue&type=script&lang=js"
export * from "./piutang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c21f674",
  null
  
)

export default component.exports